import { /* DEFAULT_MEDIA_QUERY_PLATFORMS, */ COMPONENT_TYPE as TYPE } from 'common/constants';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View from 'client/components/common/BuildingBlocks/FloatAbove/FloatAbove';

export const FLOAT_ABOVE = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.FLOAT_ABOVE,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: FLOAT_ABOVE.displayName,
					selectable: false,
					draggable: false,
					expandable: true,
					expanded: true,
				},
				nodeProps: {
					id: generateNodeId(_id, 'fla'),
				},
				componentProps: {
					styles: {},
					other: {},
				},
			},
			children: [],
		},
	};
};

FLOAT_ABOVE.displayName = 'Float above';
